/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var t,e;!function(t){t[t.Stretch=0]="Stretch",t[t.Lut=1]="Lut",t[t.Hillshade=2]="Hillshade",t[t.COUNT=3]="COUNT"}(t||(t={})),function(t){t[t.Noop=0]="Noop",t[t.PerBand=1]="PerBand",t[t.COUNT=2]="COUNT"}(e||(e={}));export{e as RasterColorizerStretchType,t as RasterColorizerType};
